import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { removeLineItem } from "../lib/draft.lib";

export function useRemoveLineItem(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (lineItemId: string) => {
    setDraft((draft) =>
      draft ? removeLineItem(draft, lineItemId) : draft,
    );
  };
}
